import { render, staticRenderFns } from "./CustomDetail.vue?vue&type=template&id=fabd3994&"
import script from "./CustomDetail.vue?vue&type=script&lang=ts&"
export * from "./CustomDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports